import Success from "../components/Success";
import { Grid } from "@mui/material";
import translations from "../translations/english.json";
import Wrapper from "../components/Wrapper";

const SuccessEn = () => {
  return (
    <Wrapper lang="en">
      <Grid container alignItems="center" justifyContent="center">
        <Success translations={translations.success} />
      </Grid>
    </Wrapper>
  );
};

export default SuccessEn;
